import { render, staticRenderFns } from "./CbsAccountSetting.vue?vue&type=template&id=3779d862"
import script from "./CbsAccountSetting.vue?vue&type=script&lang=js"
export * from "./CbsAccountSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports